import type { RouteRecordRaw } from 'vue-router';

export const tsignHistoryRoutes: RouteRecordRaw[] = [
  {
    path: '/tasks/tsign-history',
    name: 'TSignHistory',
    component: () => import('./views/TSignHistoryPage.vue'),
    meta: {
      title: 'T-Sign History',
      requiresAuth: true,
      layout: 'default',
    },
  },
];

export default tsignHistoryRoutes;

